// extracted by mini-css-extract-plugin
export default {"root":"W2ZNnD","onImage":"kVDYpL"};